import { combineReducers } from 'redux'

import commonReducers from './reducers'

export default combineReducers({
  ...commonReducers,
})
